import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { publicSupabaseConfig } from "./env";

/** Browser Supabase client. Returns null until both public settings are present. */
export function createBrowserSupabase(env?: {
  url?: string;
  anonKey?: string;
}): SupabaseClient | null {
  const config = env ? publicSupabaseConfig(env) : publicSupabaseConfig();
  if (!config) return null;
  return createClient(config.url, config.anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}

let singleton: SupabaseClient | null | undefined;

export function browserSupabase(): SupabaseClient | null {
  if (singleton !== undefined) return singleton;
  singleton = createBrowserSupabase();
  return singleton;
}
